import {
    EFE_ACTIVITY_FE_UTIL,
    getPreNumInfoByApi,
    isPc,
    isIOS as isIos,
    toggleCppIOSLink,
} from '@efe-activity-fe-util/core'
import Config from '../libs/config.json'
import { MB_CONFIG, PC_CONFIG } from '../libs/gaConfig'
import {
    ALL_GP_SELECTOR,
    ALL_IOS_SELECTOR,
    POPUP_RESERVATION_BUTTON_SELECTOR,
} from '../constants/selector'
import {
    AND_CPP_LINK_CONFIG,
    DEFAULT_LINK_CONFIG,
    IOS_CPP_LINK_CONFIG,
    TEXT_CPP_LINK,
} from '../constants/link'
import { storeTrack } from './storeTrack'

export function initPage() {
    // 初始化 ABT 视频
    initVideo()

    initUtilConfig()
    initStoreBtnLink()
    initStoreTrack()
    initRewardStatus()
}

function initVideo() {
    if (typeof window.lozad !== 'function' || !window.kvUrl) {
        return
    }

    $('.kv-video').show().addClass('loaded').append(
        // @ts-ignore
        `<video class="kv-video-box lozad" autoplay muted loop playsinline><source src="${window.kvUrl}"></source></video>`
    )

    if (isPc()) {
        $(window).on('hashchange', () => {
            const { hash } = window.location
            if (hash === '#section-01') {
                ;($(`.kv-video-box`)[0] as HTMLVideoElement)?.play?.()
            }
        })
    }
}

function initUtilConfig() {
    new EFE_ACTIVITY_FE_UTIL(Config as any, isPcLike() ? PC_CONFIG : MB_CONFIG)
    $.extend($.fn.bPopup.defaults, { appendTo: '#app' })
}

function initStoreBtnLink() {
    const { ios, gp } = DEFAULT_LINK_CONFIG
    const iosLink = normalizeLink(
        TEXT_CPP_LINK || toggleCppIOSLink(IOS_CPP_LINK_CONFIG, ios)
    )
    const gpLink = normalizeLink(toggleCppIOSLink(AND_CPP_LINK_CONFIG, gp))

    const popupStoreType = isIos() ? 'ios' : 'gp'

    $(POPUP_RESERVATION_BUTTON_SELECTOR).attr('data-store-type', popupStoreType)

    $(ALL_IOS_SELECTOR).attr({
        href: iosLink,
        target: !isPc() && isIos() ? '' : '_blank',
        // target: '_blank',
    })
    $(ALL_GP_SELECTOR).attr({ href: gpLink, target: '_blank' })
}

function initStoreTrack() {
    storeTrack()
}

async function initRewardStatus() {
    try {
        const { data } = await getPreNumInfoByApi()
        renderRewardStatus(Number(data?.totalPreNum) || 0)
    } catch {
        renderRewardStatus(0)
    }
}

function renderRewardStatus(total: number) {
    $('.reward-card[data-reward-threshold]').each((_, element) => {
        const $card = $(element)
        const threshold = Number($card.attr('data-reward-threshold'))
        const isAchieved = Number.isFinite(threshold) && total >= threshold
        const $achieved = $card.find('.reward-achieved')

        $card.toggleClass('is-achieved', isAchieved)
        // $achieved.toggle(isAchieved).toggleClass('loaded', isAchieved)
        $achieved.attr('aria-hidden', String(!isAchieved))
    })
}

function normalizeLink(link: string) {
    return link || 'javascript:void(0)'
}

function isPcLike() {
    return document.documentElement.clientWidth > 750
}
